<template>
  <div class="page-container reject-reason-list">
    <div class="page-title-container">
      <h1 class="page-title">Auditoría</h1>
    </div>

    <div class="table-container">
      <div class="table-header">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative"
        >
          <div class="w-full w-md-auto md-flex-1">
            <div
              class="d-flex justify-content-between align-items-center justify-content-lg-start"
            >
              <button
                type="button"
                class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters"
              >
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar</div>
              </button>

              <div class="d-flex d-md-none">
                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold mr-0"
                  v-b-tooltip.hover
                  title="Recargar"
                  @click="loadData()"
                >
                  <i class="ri-loop-right-line"></i>
                </button>

                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold mr-0"
                  v-b-tooltip.hover
                  title="Descargar"
                  @click="downloadReport()"
                >
                  <i class="ri-download-2-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section
            class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0"
          >
            <div class="d-none d-md-flex">
              <button
                type="button"
                class="button-tooltip text-dark font-weight-bold"
                v-b-tooltip.hover
                title="Recargar"
                @click="loadData()"
              >
                <i class="ri-loop-right-line"></i>
              </button>

              <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold ml-0"
                  v-b-tooltip.hover
                  title="Descargar"
                  v-if="$can('manage', 'auditoria_descarga_excel')"
                  @click="downloadReport()"
                >
                  <i class="ri-download-2-line"></i>
                </button>
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar
                placeholder="Buscar por usuario, descripción"
                @search="onSearch"
                @input="search = $event"
                class="flex-1"
              />
            </div>
          </section>

          <filter-menu
            :show="showFilters"
            @hide="showFilters = false"
            :options="filterOptions"
            :selectedOptionFilter="filters"
            @setFilters="setFilters"
          ></filter-menu>
        </div>

        <div
          class="w-100 d-flex flex-wrap align-items-center mt-2"
          v-if="showFiltersList"
        >
          <span
            v-for="(val, name) in filterList"
            v-bind:key="name"
            class="filter-item"
          >
            {{ getFilterName(name, val) }}
            <button
              type="button"
              class="text-white p-0 bg-transparent border-0 ml-2"
              @click="deleteFilter(name)"
            >
              <i class="ri-close-circle-line"></i>
            </button>
          </span>
        </div>
      </div>

      <div class="mb-0">
        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div>
              <span>Fecha y hora</span>
            </div>
            <div>
              <span>Usuario</span>
            </div>
          </section>

          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div>
                  <span v-local-date:hour="o.createdAt"></span>
                </div>

                <div>
                  <span>{{ trimEmail(o.actor) }}</span>
                </div>

                <div>
                  <button
                    type="button"
                    class="border-0 bg-transparent"
                    @click="o.showMobileData = !o.showMobileData"
                  >
                    <span v-if="!o.showMobileData">
                      <i class="ri-arrow-down-s-line"></i>
                    </span>
                    <span v-else>
                      <i class="ri-arrow-up-s-line"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="pt-3" v-if="o.showMobileData">
                <ul class="list-unstyled p-0">
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Acción:</span>
                    <span :class="`badge ${getAction(o.action).color}`">{{ getAction(o.action).label }}</span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Sección:</span>
                    <span>{{ getSection(o.section).label }}</span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Descripción:</span>
                    <span>{{ o.description }}</span>
                  </li>
                </ul>
                <div class="custom-table-mobile-options mt-2">
                  <a href="#" @click.prevent="openDetail(o)">Ver detalle</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
            <tr>
              <th>Acción</th>
              <th>Sección</th>
              <th>Fecha y hora</th>
              <th>Usuario</th>
              <th>Descripción</th>
              <th class="pr-md-3">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in list" :key="o.id">
              <td class="cell-center pl-3">
                <span :class="`badge ${getAction(o.action).color}`">{{ getAction(o.action).label }}</span>
              </td>
              <td class="cell-center pl-3">{{ getSection(o.section).label }}</td>
              <td class="cell-center pl-3" v-local-date:hour="o.createdAt"></td>
              <td class="cell-center px-4">{{ trimEmail(o.actor) }}</td>
              <td class="pl-5">{{ o.description }}</td>
              <td class="cell-center pr-md-3">
                <button type="button" class="border-0 bg-transparent text-primary"
                  v-b-tooltip.hover title="Ver detalle"
                  @click="openDetail(o)">
                  <i class="ri-eye-line" style="font-size: 1.1rem;"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer d-flex justify-content-end align-items-center">
        <pagination
          :total="total"
          :page="page"
          :page-size="pageSize"
          :pages="pages"
          :changePage="changePage"
          :changePageSize="changePageSize"
          v-if="list.length"
        />

        <div class="table-no-results" v-else>
          <p class="m-0 px-3">No se encontraron resultados.</p>
        </div>
      </div>
    </div>

    <!-- Modal de detalle -->
    <b-modal v-model="detailModal.show" size="xl" hide-footer
      :title="detailModal.title">
      <div v-if="detailModal.loading" class="text-center py-4">
        <i class="ri-loader-4-line spin" style="font-size: 2rem;"></i>
        <p class="mt-2 mb-0 text-muted">Cargando...</p>
      </div>

      <div v-else-if="detailModal.data">
        <div class="row mb-3">
          <div class="col-md-3">
            <small class="text-muted d-block">Acción</small>
            <span :class="`badge ${getAction(detailModal.data.action).color}`">{{ getAction(detailModal.data.action).label }}</span>
          </div>
          <div class="col-md-3">
            <small class="text-muted d-block">Sección</small>
            <strong>{{ getSection(detailModal.data.section).label }}</strong>
          </div>
          <div class="col-md-3">
            <small class="text-muted d-block">Usuario</small>
            <strong>{{ trimEmail(detailModal.data.actor) }}</strong>
          </div>
          <div class="col-md-3">
            <small class="text-muted d-block">Fecha y hora</small>
            <strong v-local-date:hour="detailModal.data.createdAt"></strong>
          </div>
        </div>

        <hr/>

        <div class="mb-3">
          <small class="text-muted d-block">Descripción</small>
          <p class="mb-0">{{ detailModal.data.description }}</p>
        </div>

        <div v-if="diffEntries.length">
          <h5 class="mb-2">Cambios detallados</h5>
          <table class="table table-sm table-bordered">
            <thead class="thead-light">
              <tr>
                <th style="width: 30%;">Campo</th>
                <th style="width: 35%;">Antes</th>
                <th style="width: 35%;">Después</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="entry in diffEntries" :key="entry.field">
                <td><strong>{{ entry.field }}</strong></td>
                <td class="text-muted"><em>{{ entry.oldValue !== null ? entry.oldValue : '—' }}</em></td>
                <td>{{ entry.newValue !== null ? entry.newValue : '—' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else-if="detailModal.data.diff && !diffParseOk" class="alert alert-light">
          <small class="text-muted">Diff sin formato:</small>
          <pre class="mb-0 small">{{ detailModal.data.diff }}</pre>
        </div>

        <div v-else class="text-muted small">
          <em>Esta acción no genera registro de cambios.</em>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  Alert,
  Constants,
  FilterMenu,
  FilterMixin,
  PaginationMixin,
  SearchBar,
  Util,
} from "wize-admin";
import fileDownload from "js-file-download"

import { Constants as LocalConstants } from "@/core/utils";
import { AuditLogService } from "@/core/services";

const HIDDEN_FIELDS = new Set([
  'id', 'status', 'isDeleted',
  'createdAt', 'updatedAt', 'createdBy', 'updatedBy',
  'filePath', 'fileUrl',
  'logoPath', 'signaturePath', 'sealPath',
  'logoUrl', 'signatureUrl', 'sealUrl',
  'signedDocumentPath', 'attachmentPath', 'attachmentUrl',
  'password', 'secret', 'token',
  'publicUuid', 'keycloakUserId',
  'documentationComplete', 'missingDocuments', 'currentContracts', 'photoAsset',
  'channelId', 'expenseLineId', 'payrollTypeIds',
  'displayStatus', 'workSchedule', 'schedule',
  'contractId', 'employeeId', 'conceptId',
  'workDaysList', 'vacationPeriodId', 'groupId',
])

const FIELD_LABELS = {
  // Persona / Empleado
  code:                         'Código',
  identifierType:               'Tipo de documento',
  identifier:                   'Número de documento',
  name:                         'Nombres',
  lastNamePaternal:             'Apellido paterno',
  lastNameMaternal:             'Apellido materno',
  fullName:                     'Nombre completo',
  nationality:                  'Nacionalidad',
  gender:                       'Género',
  birthDate:                    'Fecha de nacimiento',
  address:                      'Dirección',
  ubigeo:                       'Ubigeo',
  ubigeoDescription:            'Distrito',
  personalPhone:                'Teléfono personal',
  personalEmail:                'Correo personal',
  emergencyContact:             'Contacto de emergencia',
  emergencyContactRelationship: 'Parentesco contacto emergencia',
  bloodType:                    'Grupo sanguíneo',
  maritalStatus:                'Estado civil',
  birthUbigeo:                  'Ubigeo de nacimiento',
  hasDisability:                'Tiene discapacidad',
  disabilityType:               'Tipo de discapacidad',
  conadisCertificate:           'Certificado CONADIS',
  educationLevel:               'Nivel educativo',
  profession:                   'Profesión',
  fifthCategoryStatus:          'Estado 5ta categoría',
  // Sistema pensionario
  pensionSystem:                'Sistema pensionario',
  pensionEntity:                'Entidad pensionaria',
  cusppCode:                    'Código CUSPP',
  afpCommissionType:            'Tipo de comisión AFP',
  // Datos bancarios
  bankIdentifierType:           'Tipo doc. titular bancario',
  bankIdentifier:               'Doc. titular bancario',
  bankHolder:                   'Titular de cuenta',
  accountType:                  'Tipo de cuenta',
  bankAccount:                  'Número de cuenta',
  bankInterAccount:             'CCI',
  bank:                         'Banco',
  bankAccountVerified:          'Cuenta verificada',
  bankAccountVerifiedBy:        'Verificado por',
  ctsBank:                      'Banco CTS',
  ctsAccount:                   'Cuenta CTS',
  ctsCurrency:                  'Moneda CTS',
  // Contrato
  number:                       'Número de contrato',
  employee:                     'Colaborador',
  company:                      'Empresa',
  area:                         'Área',
  position:                     'Cargo',
  contractType:                 'Tipo de contrato',
  startDate:                    'Fecha de inicio',
  finishDate:                   'Fecha de fin',
  baseSalary:                   'Sueldo base',
  totalSalary:                  'Sueldo total',
  weeklyHours:                  'Horas semanales',
  probationEndDate:             'Fin de período de prueba',
  salaryCurrency:               'Moneda',
  directManager:                'Jefe directo',
  laborRegime:                  'Régimen laboral',
  hasFamilyAllowance:           'Asignación familiar',
  occupationalCategory:         'Categoría ocupacional',
  workerType:                   'Tipo de trabajador',
  workSite:                     'Sede de trabajo',
  specialSituation:             'Situación especial',
  corporateEmail:               'Correo corporativo',
  essaludCode:                  'Código EsSalud',
  hasEps:                       'Tiene EPS',
  epsEntity:                    'Entidad EPS',
  hasSctrPension:               'SCTR Pensión',
  hasSctrHealth:                'SCTR Salud',
  hasLifeInsurance:             'Seguro de vida ley',
  terminationDate:              'Fecha de cese',
  terminationReason:            'Motivo de cese',
  terminationNotes:             'Notas de cese',
  channelName:                  'Canal',
  expenseLineName:              'Línea de gasto',
  payrollTypeNames:             'Tipos de planilla',
  signedDocumentName:           'Documento firmado',
  signedDocumentDate:           'Fecha documento firmado',
  hasSignedDocument:            'Tiene documento firmado',
  // Horario
  workDays:                     'Días laborales',
  entryTime:                    'Hora de entrada',
  exitTime:                     'Hora de salida',
  lunchStart:                   'Inicio de almuerzo',
  lunchEnd:                     'Fin de almuerzo',
  toleranceMinutes:             'Tolerancia (min)',
  effectiveHours:               'Horas efectivas',
  // Vacaciones
  employeeName:                 'Colaborador',
  companyName:                  'Empresa',
  areaName:                     'Área',
  endDate:                      'Fecha de fin',
  calendarDays:                 'Días calendario',
  observations:                 'Observaciones',
  approvedBy:                   'Aprobado por',
  approvedAt:                   'Fecha de aprobación',
  rejectionReason:              'Motivo de rechazo',
  cancelledBy:                  'Cancelado por',
  cancelledAt:                  'Fecha de cancelación',
  cancellationReason:           'Motivo de cancelación',
  // Descanso médico
  leaveType:                    'Tipo de descanso',
  employerDays:                 'Días a cargo del empleador',
  essaludDays:                  'Días a cargo de EsSalud',
  cittNumber:                   'Número CITT',
  medicalInstitution:           'Institución médica',
  attachmentName:               'Documento adjunto',
  doctorName:                   'Médico',
  doctorSpecialty:              'Especialidad médica',
  caseStatus:                   'Estado del caso',
  processStatus:                'Estado del proceso',
  insuranceType:                'Tipo de seguro',
  dailyPayment:                 'Pago diario',
  amountPaid:                   'Monto pagado',
  amountCollected:              'Monto cobrado',
  personInCharge:               'Responsable',
  totalDays:                    'Total de días',
  subsidizedDays:               'Días subsidiados',
  employeeAge:                  'Edad del colaborador',
  employeeIdentifierType:       'Tipo doc. colaborador',
  employeeIdentifier:           'Doc. colaborador',
  // Movimiento planilla
  periodYear:                   'Año',
  periodMonth:                  'Mes',
  amount:                       'Monto',
  currency:                     'Moneda',
  origin:                       'Origen',
  description:                  'Descripción',
  installmentNumber:            'Cuota N°',
  totalInstallments:            'Total cuotas',
  totalAmount:                  'Monto total',
  installmentLabel:             'Etiqueta cuota',
  voucherType:                  'Tipo de comprobante',
  voucherNumber:                'N° de comprobante',
  conceptCode:                  'Código concepto',
  conceptName:                  'Nombre concepto',
  conceptType:                  'Tipo concepto',
  conceptNature:                'Naturaleza concepto',
  // Asistencia
  recordDate:                   'Fecha',
  dayType:                      'Tipo de día',
  attendanceStatus:             'Estado asistencia',
  tardinessMinutes:             'Tardanza (min)',
  overtimeHours:                'Horas extra',
  hoursWorked:                  'Horas trabajadas',
  // Catálogos
  ruc:                          'RUC',
  legalRepresentative:          'Representante legal',
  representativeTitle:          'Cargo del representante',
  payslipFooterText:            'Pie de boleta',
  isRequired:                   'Es obligatorio',
  mandatoryContributionRate:    'Aporte obligatorio',
  insurancePremiumRate:         'Prima de seguro',
  flowCommissionRate:           'Comisión por flujo',
  mixedCommissionRate:          'Comisión mixta',
}

export default {
  components: {
    SearchBar,
    FilterMenu,
  },
  data() {
    return {
      list: [],
      detailModal: {
        show: false,
        loading: false,
        title: 'Detalle de auditoría',
        data: null,
      },
      filterOptions: [
        {
          label: "Acción",
          key: "action",
          type: Constants.TypeFilters.SINGLE,
          options: Object.values(LocalConstants.AuditLogAction),
        },
        {
          label: "Sección",
          key: "section",
          type: Constants.TypeFilters.SINGLE,
          options: Object.values(LocalConstants.AuditLogSection),
        },
        {
          label: "Fecha",
          key: "date",
          type: Constants.TypeFilters.DATE,
          isRange: true,
        },
      ],
    };
  },
  mixins: [FilterMixin, PaginationMixin],
  computed: {
    parsedDiff() {
      if (!this.detailModal.data || !this.detailModal.data.diff) {
        return { ok: true, entries: [] };
      }
      try {
        const parsed = JSON.parse(this.detailModal.data.diff);
        const entries = Object.keys(parsed)
          .filter(field => !HIDDEN_FIELDS.has(field))
          .map(field => ({
            field:    FIELD_LABELS[field] || field,
            oldValue: parsed[field].oldValue,
            newValue: parsed[field].newValue,
          }));
        return { ok: true, entries };
      } catch (e) {
        return { ok: false, entries: [] };
      }
    },
    diffEntries() {
      return this.parsedDiff.entries;
    },
    diffParseOk() {
      return this.parsedDiff.ok;
    },
  },
  methods: {
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);

        const params = {
          page: this.page - 1,
          size: this.pageSize,
        };
        const data = { search: this.search, ...this.filters };
        const response = await AuditLogService.list(data, params);

        this.list = response.payload.content.map((item) => {
          return {
            ...item,
            showMobileData: false,
          };
        });

        this.total = response.payload.totalElements;
        this.pages = response.payload.totalPages;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors ? e.errors.message : "Error al cargar la auditoría");
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    getAction(key) {
      return Util.searchValue(key, LocalConstants.AuditLogAction) || { label: key, color: 'badge-gray' };
    },
    getSection(key) {
      return Util.searchValue(key, LocalConstants.AuditLogSection) || { label: key };
    },
    async downloadReport() {
      try {
        await this.$store.dispatch("app/loading", true);
        const data = { search: this.search, ...this.filters };
        const response = await AuditLogService.download(data);
        fileDownload(response.data, Util.getFileName(response));
      } catch (error) {
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    async openDetail(o) {
      this.detailModal.show = true;
      this.detailModal.loading = true;
      this.detailModal.data = null;
      try {
        const response = await AuditLogService.getDetail(o.id);
        this.detailModal.data = response.payload;
      } catch (e) {
        console.error(e);
        Alert.error("Error al cargar el detalle");
        this.detailModal.show = false;
      } finally {
        this.detailModal.loading = false;
      }
    },
    trimEmail(val) {
      return Util.trimEmail(val);
    }
  },
  async mounted() {
    await this.loadData(this.page, this.pageSize);
  },
};
</script>

<style lang="stylus" scoped>
.spin
  animation spin 1s linear infinite

@keyframes spin
  from
    transform rotate(0deg)
  to
    transform rotate(360deg)
</style>
